/* eslint-disable react-hooks/rules-of-hooks */
import { injectable } from 'inversify';

import { GlobalQueryService } from '../../state/queryParams/global.query.service';

import { CreateIncidentPageQuery } from './createIncident.queryParams.interface';
import { PageQuery } from '../../state/queryParams/pageQuery.service';
import { Pages } from '../../state/queryParams/pageQueries.slice';

// This is a "page query service". Its main purpose is to keep track of queryParams for this route and its relationship to global queryParams. It makes the page remember its previous queryParams when you get back. Add queryParam to the interface file and the getValidPageQueryParams method in this file.
// TODO: break out into shared service for all pages and only configure each.
@injectable()
export class CreateIncidentQueryService extends PageQuery<CreateIncidentPageQuery> {
  constructor(protected globalQueryService: GlobalQueryService) {
    super(globalQueryService, Pages.incident);
  }

  protected getValidPageQueryParams = (
    queryParams: Partial<CreateIncidentPageQuery>,
  ): CreateIncidentPageQuery => {
    return {
      selectedPlayerId: queryParams.selectedPlayerId,
    };
  };
}
